export class LanguageService {
  public static Swedish = 'sv';
  public static English = 'en';

  public static getCurrentLanguage(): string {
    return document.querySelector('html')?.getAttribute('lang') ?? '';
  }
}
